<template><div><h1 id="regionen" tabindex="-1"><a class="header-anchor" href="#regionen"><span>Regionen</span></a></h1>
<p>Regionen — Stammtabelle Regionen</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In diesem Frame werden die Stammdaten der Regionen gepflegt. Die Zuordnung von PLZ und Kantonen erfolgt in <RouteLink to="/referenz/refs/ft.refdata.regdef.html" title="Regionen definieren">Regionen definieren</RouteLink>.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Regionen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Region</dt>
<dd>Kurzbezeichnung der Region</dd>
<dt>Beschreibung</dt>
<dd>Beschreibung der Region</dd>
<dt>Parent-Gruppe</dt>
<dd>Legt fest, zu welcher <a class="link" href="ft.refdata.tblreggruppen.html" title="Regionengruppen">Regionengruppe</a> diese Region gehört.</dd>
<dt>Anzahl</dt>
<dd>Anzahl Personen in dieser Region.</dd>
<dt>Einheit</dt>
<dd>Organisatorische Einheit für die Zuordnung von regionenspezifischen Benutzerrechten.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.tblreggruppen.html" title="Regionengruppen">Regionengruppen</RouteLink>, <RouteLink to="/referenz/refs/ft.refdata.regdef.html" title="Regionen definieren">Regionen definieren</RouteLink></p>
</div></template>


